import { ComponentProps } from "react";

import AttachmentPreview from "@components/fields/AttachmentPreview";
import { RichTextareaContext } from "@components/fields/RichTextareaProvider";
import useContextSafely from "@hooks/useContextSafely";

type Props = Pick<ComponentProps<typeof AttachmentPreview>, "color">;

const RichTextareaUploadsPreview = (attachmentPreviewProps: Props) => {
  const { setUploads, setUploadsInProgress, uploads } = useContextSafely(RichTextareaContext);

  if (uploads.length === 0) return null;

  return (
    <>
      {uploads.map(upload => (
        <div className="margin-5" key={upload.upload.blobId}>
          <AttachmentPreview
            {...attachmentPreviewProps}
            onComplete={() => {
              setUploadsInProgress(currentUploads => currentUploads.filter(u => u !== upload.file));
            }}
            onDelete={() => {
              setUploadsInProgress(currentUploads => currentUploads.filter(u => u !== upload.file));
              setUploads(currentUploads => currentUploads.filter(u => u !== upload));
            }}
            uploadWithFile={upload}
          />
        </div>
      ))}
    </>
  );
};

export default RichTextareaUploadsPreview;
